import { FunctionComponent } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { allSmoLanguages, SmoLanguage } from '../../../../../../Models/Smo/SmoLanguage';
import SmoLanguageMenuActions from '../../../../../../Modules/Redux/Components/SmoLanguageMenu/SmoLanguageMenuActions';
import SmoLanguageMenuSelector from '../../../../../../Modules/Redux/Components/SmoLanguageMenu/SmoLanguageMenuSelector';
import { Menu } from '../../../../Components/Menu/Menu';
import { MenuItem } from '../../../../Components/Menu/Models/MenuItem';

export const SmoLanguageMenu: FunctionComponent = () => {
  const dispatch = useDispatch();
  const gameLanguage: string = useSelector(SmoLanguageMenuSelector.gameLanguage);

  function menuItemForLanguage(language: SmoLanguage): MenuItem {
    return {
      id: language,
      item: language
    };
  }

  function didSelectLanguage(language: string): void {
    dispatch(SmoLanguageMenuActions.updateLanguage(language as SmoLanguage));
  }

  return (
    <Menu items={allSmoLanguages.map(menuItemForLanguage)} defaultValue={gameLanguage} onChange={didSelectLanguage} />
  );
};
